import React, { useRef, useState } from "react";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { Col, Form, Row } from "react-bootstrap";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ROW_COUNT, ROW_COUNT_MAX } from "../../helpers/variableHelper";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import Loading from "../../cross/Loading";

import DesviacionService from "../../services/DesviacionService";

import { ITipo_Campo } from "../../helpers/IFormHelper";
import { dateFormatInputReference, shortDate } from "../../helpers/dateHelper";
import { EnumTipoDocumentoAuditoria } from "../../entities/helper/EnumTipoDocumentoAuditoria";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getFileName } from "../../helpers/pathHelper";
import moment from "moment";
import { E_EstadoFormIngresarLIO } from "../../enums/E_EstadoFormulario";
import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import IDocumentoLIO, { IDocumentoLIOAspectoEvaluar } from "../../entities/IDocumentoLIO";
import LIOService from "../../services/LIOService";
import { IAspectoEvaluar } from "../../entities/IInspeccionObservacion";
import { E_EstadoLIOAspectoEvaluar } from "../../enums/E_EstadoLIO";
import { ISetAspectoEvaluar } from "../../entities/IInspeccionAspectoEvaluar";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";
const MySwal = withReactContent(Swal);

interface IAgregarLIOProps {
  readonly: boolean;
  selectedAspectoEvaluar: IAspectoEvaluar | null;
  loading?: boolean;
  items?: Array<IDocumentoLIOAspectoEvaluar>;
  uploadingDoc?: boolean;
}
const AccionesAsignadasLIO = ({ readonly, selectedAspectoEvaluar, loading = true, items = [], uploadingDoc }: IAgregarLIOProps) => {
  // NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 77 como valor de complejidad cognitiva. Esta función realiza varias validaciones para la carga de las acciones, y para manejar las pruebas unitarias".
  let search = new URLSearchParams(window.location.search);
  const idLIO = parseInt(search.get("id") || "0");
  const userInfoToken = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(loading);
  const [documentosLIOAspectoAsignado, setDocumentosLIOAspectoAsignado] = useState<IDocumentoLIOAspectoEvaluar[]>(items || []);
  const refInputFile = React.createRef<HTMLInputElement>();
  const refTxtDescripcionDocumento = React.createRef<HTMLTextAreaElement>();
  const refTxtAccionRealizada = React.createRef<HTMLTextAreaElement>();
  const [fechaAccionRealizada, setFechaAccionRealizada] = useState<string>();
  const [lenAccionRealizada, setLenAccionRealizada] = useState(0);
  const [lenDescripcionDoc, setLenDescripcionDoc] = useState(0);
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [arrErrorEmptyFile, setArrErrorEmptyFile] = useState<Array<string>>([]);
  const [estadoFormulario, setEstadoFormulario] = useState<E_EstadoFormIngresarLIO>(
    readonly ? E_EstadoFormIngresarLIO.Lectura : E_EstadoFormIngresarLIO.Ingresar
  );
  const totalPageListDocumentos = useRef<number>(0);
  const [isSendingData, setIsSendingData] = useState(false);
  const [isUploadingDoc, setIsUploadingDoc] = useState(uploadingDoc || false);
  console.log(arrErrorEmptyFile);
  console.log(estadoFormulario);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentLoading = () => {
    if (isSendingData) {
      return <Loading />;
    } else {
      return (
        <span>
          <button
            className="btn btn-sm btn-primary me-2"
            onClick={() => {
              handleAccion(false);
            }}
            disabled={isSendingData}>
            Guardar
          </button>
          <button
            className="btn btn-sm btn-primary me-2"
            onClick={() => {
              handleAccion(true);
            }}
            disabled={isSendingData}>
            Acción Realizada
          </button>
        </span>
      );
    }
  };

  const componentEliminar = (info: any) => {
    return (
      <div>
        {info.row.original.ID != null ? (
          <i
            className="bi bi-trash iconTrash text-dander pointer"
            title="Eliminar Documento"
            onClick={() => {
              MySwal.fire({
                html: (
                  <div>
                    <h3>¿Desea eliminar el documento {getFileName(info.row.original.URL)}?</h3>
                  </div>
                ),
                text: "",
                icon: "question",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                showCloseButton: true,
                showCancelButton: true,
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await LIOService.deleteDocumentoLIOAspectoEvaluar(token, info.getValue());

                  await refreshDocuments(null);
                }
              });
            }}></i>
        ) : (
          <React.Fragment />
        )}
      </div>
    );
  };

  const componentVer = (info: any) => {
    return (
      <div>
        <i
          data-testid="Ver Documento"
          className="bi bi-search iconSearch pointer colorAzul"
          title="Ver Documento"
          onClick={() => {
            DesviacionService.getContenidoArchivo(token, info.row.original.URL);
          }}></i>
      </div>
    );
  };
  usePromiseEffect(async () => {
    let token = await userInfoToken;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    setEstadoFormulario(E_EstadoFormIngresarLIO.IngresarLIO);
    setIsLoading(false);
    if (selectedAspectoEvaluar?.ID) {
      refreshDocuments();
      setLenAccionRealizada(selectedAspectoEvaluar?.ACCION_REALIZADA?.length || 0);
      if (selectedAspectoEvaluar?.FECHA_ACCIONAR) {
        setFechaAccionRealizada(moment(selectedAspectoEvaluar?.FECHA_ACCIONAR).format("yyyy-MM-DD"));
      }
    }
  }, []);

  let paramsActive = {
    PAGINA: 1,
    PAGINADO: ROW_COUNT_MAX,
    ORDENADOPOR: "ID",
    ORIENTACION: "ASC",
    ACTIVO: true,
  };

  const refreshDocuments = async (pagination?: IPagination | null) => {
    const defaultPagination: IPagination = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "ASC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    if (selectedAspectoEvaluar?.ID) {
      let result = await LIOService.getDocumentosLIOAspectoEvaluar(token, {
        ...defaultPagination,
        ID_TIPO_DOCUMENTO: EnumTipoDocumentoAuditoria.AspectoAsignado,
        ID_LIO_INSPECCION_OBSERVACION: idLIO,
        ID_LIO_ASPECTO_EVALUAR: selectedAspectoEvaluar?.ID,
      });
      totalPageListDocumentos.current = result.pages;
      setDocumentosLIOAspectoAsignado(result.resultCode !== 500 ? result.data : items);
    }
  };

  const formValidation = (value: ISetAspectoEvaluar) => {
    let arrErrors: Array<string> = [];

    if (!value.ACCION_REALIZADA) {
      arrErrors.push("ACCION_REALIZADA");
    }

    if (!moment(value.FECHA_ACCION_REALIZADA).isValid()) {
      arrErrors.push("FECHA_ACCION_REALIZADA");
    }
    if (value.MARCAR_ACCION_REALIZADA && documentosLIOAspectoAsignado.length === 0) {
      arrErrors.push("EVIDENCIAS");
      MySwal.fire({
        html: (
          <div>
            <h3>Debe adjuntar evidencia</h3>
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const handleAccion = async (marcarAccionRealizada: boolean) => {
    let value: ISetAspectoEvaluar = {
      ID: selectedAspectoEvaluar?.ID as number,
      ID_INSPECCION_OBSERVACION: selectedAspectoEvaluar?.ID_INSPECCION_OBSERVACION as number,
      ID_ESTADO: selectedAspectoEvaluar?.ID_ESTADO,
      FECHA_ACCION_REALIZADA: new Date(fechaAccionRealizada as string),
      ACCION_REALIZADA: refTxtAccionRealizada.current?.value as string,
      MARCAR_ACCION_REALIZADA: marcarAccionRealizada,
      ACCION_REALIZADA_POR: marcarAccionRealizada ? currentUser?.email : null,
      ACCION_REALIZADA_POR_DISPLAY: marcarAccionRealizada ? currentUser?.fullname : null,
      FECHA_MODIFICACION: new Date(),
      EDITOR: currentUser?.fullname,
      EDITOR_DISPLAY: currentUser?.fullname,
    };

    if (formValidation(value)) {
      setIsSendingData(true);
      let id = await LIOService.setAspectoEvaluarAccionAsignada(token, value);
      if (marcarAccionRealizada) {
        let result = (
          await LIOService.getListadoAspectoAsignadoInsObs(token, {
            ...paramsActive,
            ID_INSPECCION_OBSERVACION: idLIO,
          })
        ).data;
        if (result.every((aa) => aa.ID_ESTADO === E_EstadoLIOAspectoEvaluar.AccionRealizada)) {
          window.location.reload();
        } else {
          window.location.href = "/lio";
        }
      } else {
        setIsSendingData(false);
      }
      return id;
    } else {
      return -1;
    }
  };

  const validateUploadFile = (value: Partial<IDocumentoLIO>) => {
    let arrErrors: Array<string> = [];

    if (!refInputFile.current?.files) {
      arrErrors.push("ARCHIVO");
    } else {
      if (documentosLIOAspectoAsignado.filter((l) => l.URL.includes((refInputFile.current?.files as FileList)[0].name)).length > 0) {
        arrErrors.push("ARCHIVO_DUPLICADO");

        MySwal.fire({
          html: (
            <div>
              <h3>Archivo "{(refInputFile.current?.files)[0].name}" ya se encuentra cargado</h3>
            </div>
          ),
          text: "",
          icon: "error",
          showCloseButton: true,
        });
      }
    }

    setArrErrorEmptyFile(arrErrors);
    return arrErrors.length === 0;
  };

  const handleGuardarDocumento = async () => {
    let f = (refInputFile.current?.files as FileList)[0] as any;
    let value: Partial<IDocumentoLIOAspectoEvaluar> = {
      ID_TIPO_DOCUMENTO: EnumTipoDocumentoAuditoria.AspectoAsignado,
      ID_LIO_INSPECCION_OBSERVACION: idLIO,
      ID_LIO_ASPECTO_EVALUAR: selectedAspectoEvaluar?.ID as number,
      DESCRIPCION: refTxtDescripcionDocumento.current?.value,
      FILE: f,
    };
    if (validateUploadFile(value)) {
      setIsUploadingDoc(true);
      if (selectedAspectoEvaluar?.ID != null) {
        value.ID_LIO_INSPECCION_OBSERVACION = idLIO;
        await LIOService.addDocumentosLIOAspectoEvaluar(token, value);
        await refreshDocuments();
        setIsUploadingDoc(false);

        setLenDescripcionDoc(0);
        (refTxtDescripcionDocumento.current as HTMLTextAreaElement).value = "";
        (refInputFile.current as HTMLInputElement).value = "";
      }
    }
  };

  const columnHelperLIODocumentos = createColumnHelper<IDocumentoLIO>();
  let columnsDefLIODocumentos = [
    columnHelperLIODocumentos.accessor((row) => row.URL, {
      id: "URL",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentValue(getFileName(info.getValue())),
      header: () => component("Nombre Documento"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIODocumentos.accessor((row) => row.ID, {
      id: "CATEGORIA",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentValue("Acciones Asignadas"),
      header: () => component("Categoría"),
      tipo: ITipo_Campo.text,
      hide: true,
    } as any),
    columnHelperLIODocumentos.accessor((row) => row.DESCRIPCION, {
      id: "DESCRIPCION",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIODocumentos.accessor((row) => row.ID, {
      id: "ACCION_VER",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentVer(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperLIODocumentos.accessor((row) => row.ID, {
      id: "ACCION_ELIMINAR",
      cell: (info: CellContext<IDocumentoLIO, number>) => componentEliminar(info),
      header: () => component("Eliminar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: readonly,
    } as any),
  ] as any;

  return isLoading ? (
    <>
      <Loading />-
    </>
  ) : (
    <div className="rounded bg-white p-2 shadow">
      <div className="container-fluid mb-4">
        <h1 className="titPrincipal colorTit">{selectedAspectoEvaluar?.NUEVO_FORMATO_FAENA ? "Acciones" : "Aspectos"}</h1>
        <div className="card bg-light border p-3 pt-2 mt-2">
          <Row>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>{selectedAspectoEvaluar?.NUEVO_FORMATO_FAENA ? "N° Acción:" : "N° Aspecto:"}</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <span>{selectedAspectoEvaluar?.TITULO}</span>
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Fecha Asignación:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <span>{shortDate(selectedAspectoEvaluar?.FECHA_ASIGNACION)}</span>
                </Col>
              </div>

              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Fecha Hasta:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <span>{shortDate(selectedAspectoEvaluar?.FECHA_HASTA)}</span>
                </Col>
              </div>

              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  {readonly || (
                    <span className="text-danger">
                      <strong>(*)</strong>
                    </span>
                  )}
                  <label>Acción Realizada:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {readonly ? (
                    <span>{selectedAspectoEvaluar?.ACCION_REALIZADA}</span>
                  ) : (
                    <span>
                      <textarea
                        className={`form-control form-control-sm ${arrErrorEmpty.includes("ACCION_REALIZADA") && "error"}`}
                        rows={3}
                        ref={refTxtAccionRealizada}
                        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setLenAccionRealizada(e.target.value.length)}
                        maxLength={1000}
                        defaultValue={selectedAspectoEvaluar?.ACCION_REALIZADA || ""}></textarea>
                      <span>{lenAccionRealizada}/1000</span>
                    </span>
                  )}
                </Col>
              </div>
              {selectedAspectoEvaluar?.ID_ESTADO === E_EstadoLIOAspectoEvaluar.Rechazado && (
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <label>Motivo Rechazo:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <span>{selectedAspectoEvaluar?.MOTIVO_RECHAZO}</span>
                  </Col>
                </div>
              )}
            </Col>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>{selectedAspectoEvaluar?.NUEVO_FORMATO_FAENA ? "Nombre Acción:" : "Nombre Aspecto:"}</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <span>{selectedAspectoEvaluar?.NOMBRE_ELEMENTO}</span>
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Responsable Acción:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <span>{selectedAspectoEvaluar?.RESPONSABLE_DISPLAY}</span>
                </Col>
              </div>
              {!selectedAspectoEvaluar?.NUEVO_FORMATO_FAENA && (
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="4">
                    <label>Acción a Realizar:</label>
                  </Col>
                  <Col xs="12" md="6" lg="8">
                    <span>{selectedAspectoEvaluar?.OBSERVACION}</span>
                  </Col>
                </div>
              )}
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  {readonly || (
                    <span className="text-danger">
                      <strong>(*)</strong>
                    </span>
                  )}
                  <label>Fecha Acción Realizada:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  {readonly ? (
                    <span>{shortDate(selectedAspectoEvaluar?.FECHA_ACCIONAR)} </span>
                  ) : (
                    <Form.Control
                      onChange={(e) => {
                        setFechaAccionRealizada(e.target.value);
                      }}
                      type="date"
                      defaultValue={
                        selectedAspectoEvaluar?.FECHA_ACCIONAR
                          ? moment(selectedAspectoEvaluar?.FECHA_ACCIONAR).format("yyyy-MM-DD")
                          : fechaAccionRealizada
                      }
                      className={`${arrErrorEmpty.includes("FECHA_ACCION_REALIZADA") && "error"}`}
                      max={moment().format(dateFormatInputReference)}
                    />
                  )}
                </Col>
              </div>
            </Col>
          </Row>

          {isUploadingDoc ? (
            <Loading />
          ) : (
            <div className="row mb-2 ajusteInput">
              <div className="col-sm-12 col-md-12 col-lg-12 mb-2">
                <h5 className="titPaneles">Evidencias</h5>
              </div>
              {readonly || (
                <div className="row border m-1 p-1 rounded">
                  <div className="col-sm-12 col-md-12 col-lg-2 mb-2">
                    <label>Descripción</label>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-10 mb-2">
                    <textarea
                      className="form-control form-control-sm"
                      rows={3}
                      ref={refTxtDescripcionDocumento}
                      onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setLenDescripcionDoc(e.target.value.length)}
                      maxLength={250}></textarea>
                    <span>{lenDescripcionDoc}/250</span>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-2 mb-2">
                    <label>Adjuntar </label>
                    <span className="text-danger">
                      <small> Peso maximo (50 mb).</small>
                    </span>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-10 mb-2">
                    <div className="input-group">
                      <input
                        type="file"
                        className="form-control form-control-sm"
                        id="inputGroupFile04"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Seleccionar Archivos"
                        ref={refInputFile}
                      />
                      <button
                        className="btn btn-primary btn-sm"
                        type="button"
                        id="inputGroupFileAddon04"
                        onClick={() => {
                          handleGuardarDocumento();
                        }}>
                        Subir
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="row mb-2 ajusteInput">
                <AdminListaPagination
                  defaultSortBy="ID"
                  sortDirection="DESC"
                  totalPages={totalPageListDocumentos}
                  resultPerPage={ROW_COUNT}
                  callback={(pagination) => {
                    refreshDocuments(pagination);
                  }}
                  data={documentosLIOAspectoAsignado}
                  reload={() => {
                    refreshDocuments();
                  }}
                  columnsDef={columnsDefLIODocumentos}
                  hideAdd={true}
                  hideExport={true}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="container-fluid mb-4">
        <div className="card bg-light border p-3 pt-2 mt-2">
          <div className="row mb-2 ajusteInput mt-4">
            <Col xs="4" md="4" lg="4"></Col>
            <Col xs="4" md="4" lg="4" className="text-center">
              {!readonly ? componentLoading() : <></>}
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={() => {
                  window.location.href = "/lio";
                }}
                disabled={isSendingData}>
                Volver
              </button>
            </Col>
            <Col xs="4" md="4" lg="4"></Col>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AccionesAsignadasLIO;
